<template>
  <div class="antialiased">

    <Sidebar/>

    <div class="page">
      
      <Header hint="Cari" :enabled="false"/>

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                  Laporan Target Sales
                </h2>
              </div>
              <div class="col-auto">
                <div class="row">
                  <div class="col-auto px-0">
                  </div>
                  <div class="col-auto">
                    <button class="btn btn-white" v-html="ic('filter')+' Filter'" @click="_filter"> </button>
                    <a v-if="data.length > 0" class="btn btn-primary ml-3" :href="downloadLink" target="_blank"  v-html="ic('download')+' Export Excel'"></a>
                    <!-- <button class="btn btn-primary ml-3" v-html="ic('download')+' Export Excel'" @click="_exportExcel"> </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>

          <Nodata v-if="!loading && data.length == 0 && isFilter"/>
          <div class="alert alert-info" v-if="!isFilter && !loading">
            <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat data Target Sales
          </div>
          <div class="text-center my-6" v-if="!loading && data.length > 0">
            <!-- <img :src="asset('doc.png')" alt="" style="width: 200px; opacity: .5">
            <h3 class="my-3" v-html="data.length+' Data'"></h3> -->
            <div class="box">
                        <div class="card">
                            <div class="table-responsive">
                                <table class="table table-vcenter table-hover card-table table-striped table-control table-no-break">
                                    <thead class="text-muted">
                                        <tr>
                                            <th class="text-center" colspan="14">Tracking Sales Target</th>
                                        </tr>
                                        <tr>
                                            <th>Tim</th>
                                            <th>Brand</th>
                                            <th>Target Volume</th>
                                            <th>Target OA</th>
                                            <th>Cartoon Week 1 </th>
                                            <th>OA Week</th>
                                            <th>Cartoon Week 2 </th>
                                            <th>OA Week 2</th>
                                            <th>Cartoon Week 3 </th>
                                            <th>OA Week 3</th>
                                            <th>Cartoon Week 4 </th>
                                            <th>OA Week 4</th>
                                            <th>Total Volume</th>
                                            <th>Archivement Volume</th>
                                            <th>Gap Volume</th>
                                            <th>Total OA</th>
                                            <th>Archivement OA</th>
                                            <th>Gap OA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(k, i) in data">
                                        <td><span class="badge bg-blue-lt mr-2">{{k.tim}}</span></td>
                                        <td><span class="badge bg-blue-lt mr-2">{{k.brand}}</span></td>
                                        <td>{{ k.target_carton }}</td>
                                        <td>{{ k.target_oa }}</td>
                                        <td>{{ k.carton_1 }}</td>
                                        <td>{{ k.oa_1 }}</td>
                                        <td>{{ k.carton_2 }}</td>
                                        <td>{{ k.oa_2 }}</td>
                                        <td>{{ k.carton_3 }}</td>
                                        <td>{{ k.oa_3 }}</td>
                                        <td>{{ k.carton_4 }}</td>
                                        <td>{{ k.oa_4 }}</td>
                                        <td>{{ k.total_carton }}</td>
                                        <td>{{ k.archivement_carton }}</td>
                                        <td>{{ k.gap_carton }}</td>
                                        <td>{{ k.total_oa }}</td>
                                        <td>{{ k.archivement_oa }}</td>
                                        <td>{{ k.gap_oa }}</td>
                                      </tr>
                                      </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
            <!-- <div class="btn-group">
              <button class="btn btn-primary" @click="_createExcel">Export Excel</button>
            </div> -->
                
          </div>

        </div>
      </div>

    </div>

    <FormFilter
      :config.sync="filter.config"
      :initData="filter.data" :dismiss.sync="filter.dismiss"
      :isSubmit.sync="filter.isSubmit"
      @submit="filter.action"
    />

  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";

import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "TrackingSalesTarget",
  components: { FormFilter },

  data() {
    return {
      auth: {},

      filter: {
        config: { view: false, title: null },
        data: null, isSubmit: false,
        action: () => {}
      },

      loading: false, isFilter: false,
      data: [],
      downloadLink : "",
  
      dataFilter: {
       id_tim:[],
       id_brand:[],
       bulan : null,
       tahun: null,
       type_date : '',
      },
    };
  },

  mixins: [helper],

  methods: {
      _exportExcel(){

      },

      _get(){
        this.loading = true
        let id_tim = "";
        let id_brand = "";
        this.dataFilter.id_tim.map(e => id_tim = id_tim+"id_tim[]="+e+"&")
        this.dataFilter.id_brand.map(e => id_brand = id_brand+"id_brand[]="+e+"&")
        let url = "tracking_sales_target?"+id_tim+id_brand+"bulan="+this.dataFilter.bulan+"&tahun="+this.dataFilter.tahun+"&type_date="+this.dataFilter.type_date;
        this.axios.get(url,this.dataFilter).then(res => {
          this.loading = false;
          if(res.data.data.length != 0){
            this.data = res.data.data
            this.downloadLink = res.data.link
          }
        }).catch( err => {
          this.loading = false
          this.onError(err)
        });
      },

      _filter(){
        this.filter.config = {view: true, title: 'Filter'}
        this.filter.action = (formData) => {
          this.isFilter = true

          for (const key in formData) {
            this.dataFilter[key] = formData[key]
          }

          this._get()
        }
      },

      _createExcel(){
        this.createExcel({data: this.data, filename: 'laporan-target-sales-'+this.dataFilter.bulan+' - '+this.dataFilter.tahun})
      }
    
  },

  mounted(){
    this.auth = JSON.parse(localStorage.user)
  },

};
</script>
